import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-responsive-modal';
import store from '../../../../../storeClient';
import ConsultasClient from '../../../../api/consultas';
import { adultsQtyMapper } from 'frontend/helpers/julia-mappers';
import { useColors } from 'frontend/hooks/useColors';

const ConsultaModal = ({ consultaPackage, onClose }) => {
  const { t } = useTranslation(['translations', 'layout']);
  const { token, applicationId, paisId, templateData } = store.getState().applicationState;
  const { background, text } = useColors();
  const nombreAgencia = store.getState().applicationState.nombre;
  const [nombre, setNombre] = useState('');
  const [email, setEmail] = useState('');
  const [apellido, setApellido] = useState('');
  const [telefono, setTelefono] = useState('');
  const [comentarios, setComentarios] = useState('');
  const [consulta, setConsulta] = useState({
    estadoConsulta: '',
  });

  const resetForm = () => {
    setNombre('');
    setApellido('');
    setEmail('');
    setTelefono('');
    setComentarios('');
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const getTotalPrice = (price, taxTotal) => {
    return Number(price) + Number(taxTotal);
  };

  const enviarConsulta = useCallback(
    (e) => {
      e.preventDefault();
      let data = {
        nombre,
        apellido,
        nombreMail: nombre + ' ' + apellido,
        email,
        telefono,
        comentarios,
        paisId,
        provider: consultaPackage.providerName,
        nombreAgencia,
        tituloPaquete: consultaPackage.title,
        numeroPaquete: consultaPackage.externalId,
        origenPaquete: consultaPackage.packageOrigins[0].originExporta.nombreCiudad,
        destinoPaquete: consultaPackage.packageDestinations[0].destinationCity.nombreCiudad,
        habitacionPaquete: 1, // this is the number of rooms, hardcoded now, but should be dynamic for other providers
        categoriaHabitacionPaquete: consultaPackage.hotelInformation[0].roomType,
        cantidadPersonasPaquete: adultsQtyMapper(consultaPackage.hotelInformation[0].occupation),
        precioTotalPaquete: consultaPackage.total,
        tipoConsulta: 'paquete',
        agenciaId: applicationId,
        emailAgencia: templateData?.header.emailContacto,
        link: consultaPackage?.link,
      };

      ConsultasClient.consultaMarcaBlanca(data, token).then((res) => {
        if (res.status === 201) {
          setConsulta({
            estadoConsulta: 'enviado',
          });
          data.id = res.data.id;
          ConsultasClient.enviarMailConsulta(data, token).then((res) => {
            if (res.status === 201) {
              console.log('Email Sent');
            } else {
              console.error('EMAIL - Error');
            }
          });
          alert('La consulta se envió correctamente');
          handleClose();
        } else {
          setConsulta({
            estadoConsulta: 'error',
          });
          alert('La consulta no se pudo enviar');
        }
      });
    },
    [nombre, email, telefono, comentarios, consultaPackage],
  );

  const handleNombreChange = (event) => {
    setNombre(event.target.value);
  };

  const handleApellidoChange = (event) => {
    setApellido(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleTelefonoChange = (event) => {
    const value = event.target.value;
    if (value.length <= 20) {
      setTelefono(value);
    }
  };

  const handleComentariosChange = (event) => {
    setComentarios(event.target.value);
  };

  return (
    !!consultaPackage && (
      <Modal classNames={{ modal: 'package-modal consulta-package-modal' }} open onClose={onClose}>
        <div className="modal-package-search__header">
          <i
            className="fa fa-paper-plane package-search__icon text-footer-default"
            style={{ color: background }}
          />
          <div className="package-search__form__title">{t('translations:submit_your_inquiry')}</div>
        </div>
        <form className="form-inline consulta-modal__content" onSubmit={enviarConsulta}>
          <div className="form-group">
            <div className="clearfix" />
            <span className="block text-gray-700 text-sm font-bold mb-2">
              {t('requestForm.name')} (*)
            </span>
            <input
              id="nombre"
              onChange={handleNombreChange}
              value={nombre}
              name="{t('requestForm.name')}"
              type="text"
              maxLength={50}
              className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
              required
            />
          </div>
          <div className="form-group">
            <div className="clearfix" />
            <span className="block text-gray-700 text-sm font-bold mb-2">
              {t('requestForm.lastName')} (*)
            </span>
            <input
              id="apellido"
              onChange={handleApellidoChange}
              value={apellido}
              name={t('requestForm.surname')}
              type="text"
              maxLength={50}
              className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full ma-2"
              required
            />
          </div>
          <div className="form-group">
            <span className="block text-gray-700 text-sm font-bold mb-2">E-mail (*)</span>
            <input
              id="email"
              onChange={handleEmailChange}
              value={email}
              name={t('requestForm.email')}
              type="email"
              maxLength={50}
              className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
              required
            />
          </div>
          <div className="form-group">
            <span className="block text-gray-700 text-sm font-bold mb-2">
              {t('requestForm.phone')}
            </span>
            <input
              id="telefono"
              onChange={handleTelefonoChange}
              value={telefono}
              name={t('requestForm.phone')}
              type="number"
              maxLength={20}
              className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
            />
          </div>
          <div className="form-group">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="comentarios">
              {t('requestForm.message')} (*)
            </label>
            <textarea
              id="comentarios"
              onChange={handleComentariosChange}
              value={comentarios}
              name={t('translations:message')}
              className="h-36 shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
              rows="5"
              placeholder={t('requestForm.commentsPlaceholder')}
              required
            />
          </div>
          <div className="package-search__button-row">
            <button
              className="package-search__button big-package-search__button"
              style={{
                backgroundColor: background,
                color: text,
              }}
            >
              <i className="fa fa-paper-plane heading__icon" />
              Enviar
            </button>
          </div>
        </form>
      </Modal>
    )
  );
};

export default ConsultaModal;
